import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@shared/components/confirmation-dialog/confirmation-dialog.component';

@Injectable()
export class ConfirmationService {

  constructor(private dialog: MatDialog) { }
  async showConfirmation(title?: string, subTitle?: string, boldTitle?: string, showSubtitle?: boolean, showBoldTitle?: boolean, confirmButtonText?: string): Promise<boolean> {
    const ref = this.dialog.open(ConfirmationDialogComponent);
    const instance = ref.componentInstance;
    instance.title = title;
    instance.subTitle = subTitle;
    instance.boldTitle = boldTitle;
    instance.showSubtitle = showSubtitle;
    instance.showBoldTitle = showBoldTitle;
    instance.confirmButtonText = confirmButtonText;
    return ref.afterClosed().toPromise();
  }
}
